import { createContext, useContext, useReducer } from 'react';

const AppStateContext = createContext(null);

const AppDispatchContext = createContext(null);

function appReducer(appState, fn) {
  return fn(appState);
}

export function AppProvider({
  children,
  initialState = {},
}) {
  const [appState, appDispatch] = useReducer(
    appReducer,
    initialState
  );

  return (
    <AppStateContext.Provider value={appState}>
      <AppDispatchContext.Provider value={appDispatch}>
        {children}
      </AppDispatchContext.Provider>
    </AppStateContext.Provider>
  );
}

export function useAppState() {
  return useContext(AppStateContext);
}

export function useAppDispatch() {
  return useContext(AppDispatchContext);
}
